define('modules/lp_leads/views/integrations_popup',['require','exports','module','backbone','common/views/modal_view','ldsh!../templates/lead_listing_popup'],function(require, exports, module){
  "use strict";

  var Backbone = require("backbone"),
      ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/lead_listing_popup"),
    triggers: {
      "click .js-close": "close",
      "click .js-cancel": "close",
    },
    initialize: function(options){
      this.status = options.status || new Backbone.Model();
      this.status.set("webservice", this.status.get("post"));
      this.tracking = options.tracking || {};
    },
    helpers: function() {
      return {
        availableIntegrations: ["webservice", "mdirector", "correodirect", "zapier"],
        hasIntegration: _.bind(function(integration){
          return this.status.has(integration);
        }, this),
        isActive: _.bind(function(integration){
          return this.status.get(integration);
        }, this),
        getResponse: _.bind(function(integration){
          return this.model.get("int_" + integration + "_response");
        }, this),
        isTracking: _.bind(function(integration){
          return integration === this.tracking.reqConversion;
        }, this)
      };
    },
    onRender: function() {
      this.$el.i18n();
    }
  },{
    show: function(options) {
      var popup = new module.exports(options);
      popup.on("close", popup.hide, popup);
    }
  });
});

